import { LanguageService } from '../service/language.service';
import { Translation } from './translation';

export class Phrase {
  constructor(
    translations: Translation[],
    private _languageService: LanguageService
  ) {
    this.translations =
      translations && Array.isArray(translations) ? translations.map(t => new Translation(t.cultureName, t.translationText)) : [];
  }
  translations: Translation[];

  /** Translation text for the current language (or null). */
  get currentTranslationText(): string {
    const translation = this.translations.find(t => t.cultureName === this._languageService.currentCultureLang);
    return translation?.translationText || null;
  }

  /** Every translation *except* the current one. */
  get otherTranslations(): Translation[] {
    return this.translations.filter(x => x.cultureName !== this._languageService.currentCultureLang);
  }

  getTranslationWithFallback(cultureName?: string): string {
    if (!cultureName) {
      cultureName = this._languageService.currentCultureLang;
    }
    let translation = this.translations.find(t => t.cultureName === cultureName && t.translationText);
    if (!translation && cultureName !== this._languageService.currentCultureLang) {
      translation = this.translations.find(t => t.cultureName === this._languageService.currentCultureLang && t.translationText);
    }
    if (!translation) {
      translation = this.translations.find(t => t.translationText);
    }
    return translation ? translation.translationText : null;
  }

  setTranslation(cultureName: string, value: string): void {
    let translation = this.translations.find(t => t.cultureName === cultureName);
    if (translation) {
      translation.translationText = value;
      if (!value) {
        this.translations.splice(this.translations.indexOf(translation), 1);
      }
    } else {
      if (value) {
        this.translations.push(new Translation(cultureName, value));
      }
    }
  }

  setCurrentTranslation(value: string): void {
    let culture = this._languageService.currentCultureLang;
    this.setTranslation(culture, value);
  }

  getAllTranslations(): Translation[] {
    let translations = [];
    let supportedLanguages = this._languageService.getSupportedLanguages();
    for (let lang of supportedLanguages) {
      let currentValue = this.translations.find(t => t.cultureName === lang.culture);
      translations.push(currentValue ? currentValue : new Translation(lang.culture, null));
    }

    let sortedTranslations = [translations.find(l => l.cultureName === this._languageService.currentCultureLang)];
    for (let translation of translations.filter(l => l.cultureName !== this._languageService.currentCultureLang)) {
      sortedTranslations.push(translation);
    }
    this.translations = sortedTranslations;
    return this.translations;
  }
}
